import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails10 = () => {
  const psbData = {
    title: "Utpann PSB",
    category: "Phosphate Solubilizing Bacteria",
    description:
      "PSB (Phosphate Solubilizing Bacteria) helps release fixed phosphorus in soil, making it readily available to plants. It supports early root establishment, vigorous plant growth, and better nutrient uptake. Regular application of PSB improves crop yield, reduces phosphorus fertilizer dependency, and enhances soil health.",
    price: "600",
    image: "/assets/Product/img10.png",
    priceNote: "Per 500gm Pack (Gujarat) (Inc GST)",
    recommendations: ["All Crops", "Release Fixed Phosphorus", "Boost Crops"],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      { label: "Total viable count", value: "CFU minimum 5x10(7) cell/gram" },
      {
        label: "Contamination Level",
        value: "No contamination at 10(5) dilution",
      },
      { label: "pH", value: "5.0-7.0" },
      {
        label: "Efficiency Character",
        value:
          "The strain should be capable of solubilizing at least 30mg/liter",
      },
    ],
    packaging: [
      { label: "Bulk", value: "1000 MT FIBC" },
      { label: "Standard Pack", value: "500gm" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Enhances phosphorus availability in soil",
      "Improves root development and plant vigor",
      "Increases nutrient uptake efficiency",
      "Supports sustainable agriculture with eco-friendly biofertilization",
      "Enhance microbial activity in the soil",
      "Promotes early seed germination and plant establishment",
      "Improves soil structure and fertility overtime",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={psbData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails10;
